/* Boot: fonts and styles, i18n, the mock API (when on), then the router. */
import '@fontsource/ibm-plex-sans-arabic/400.css'
import '@fontsource/ibm-plex-sans-arabic/600.css'
import '@fontsource/ibm-plex-sans-arabic/700.css'
import '@fontsource/readex-pro/600.css'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'
import './styles/app.css'
import './i18n'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router/dom'
import { Providers } from '@/app/providers'
import { router } from '@/app/router'
import { isMock } from '@/lib/env'

async function boot() {
  if (isMock) {
    const { startMockApi } = await import('@/api/mock/browser')
    await startMockApi()
  }
  const el = document.getElementById('root')
  if (!el) throw new Error('#root missing')
  createRoot(el).render(
    <StrictMode>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </StrictMode>,
  )
}

void boot()
